import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';

export default css({
  '.download-files-button': {
    '&__btn': {
      whiteSpace: 'nowrap',
      '& svg': {
        color: COLORS.NEUTRAL500,
      },
    },
  },
});
